import TrialBalancePage from "../Components/Credora/Accounting/TrialBalancePage";
import BalanceSheetPage from "../Components/Credora/Accounting/BalanceSheetPage";
import IncomeStatementPage from "../Components/Credora/Accounting/IncomeStatementPage";
import CashFlowPage from "../Components/Credora/Accounting/CashFlowPage";
import GeneralLedgerPage from "../Components/Credora/Accounting/GeneralLedgerPage";
import BudgetVsActualPage from "../Components/Credora/Accounting/BudgetVsActualPage";
import FinanceReportsHubPage from "../Components/Credora/Reports/FinanceReportsHubPage";
import FinanceReportsExportPage from "../Components/Credora/Reports/FinanceReportsExportPage";
import VatSummaryReportPage from "../Components/Credora/Reports/VatSummaryReportPage";

const REPORT_MODE = { reportMode: true };

/**
 * @param {(path: string) => string} p - credora path helper from credoraRouteRegistry
 */
export function buildFinanceReportRoutes(p) {
  return [
    { path: p("/credora/reports/finance/:layout"), element: <FinanceReportsHubPage /> },
    { path: p("/credora/reports/finance/trial-balance/:layout"), element: <TrialBalancePage {...REPORT_MODE} /> },
    { path: p("/credora/reports/finance/balance-sheet/:layout"), element: <BalanceSheetPage {...REPORT_MODE} /> },
    { path: p("/credora/reports/finance/income-statement/:layout"), element: <IncomeStatementPage {...REPORT_MODE} /> },
    { path: p("/credora/reports/finance/cash-flow/:layout"), element: <CashFlowPage {...REPORT_MODE} /> },
    { path: p("/credora/reports/finance/general-ledger/:layout"), element: <GeneralLedgerPage {...REPORT_MODE} /> },
    { path: p("/credora/reports/finance/budget-vs-actual/:layout"), element: <BudgetVsActualPage {...REPORT_MODE} /> },
    { path: p("/credora/reports/finance/vat-summary/:layout"), element: <VatSummaryReportPage /> },
    { path: p("/credora/reports/finance/export/:layout"), element: <FinanceReportsExportPage /> },
  ];
}

/** Path keys for menu access / RBAC (no layout slug). */
export function financeReportPathKeys() {
  return [
    "reports/finance",
    "reports/finance/trial-balance",
    "reports/finance/balance-sheet",
    "reports/finance/income-statement",
    "reports/finance/cash-flow",
    "reports/finance/general-ledger",
    "reports/finance/budget-vs-actual",
    "reports/finance/vat-summary",
    "reports/finance/export",
  ];
}
